import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import {
    getDeviceType,
    getVersion,
    serviceErrorToAnalyticsFormat,
} from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';

export class CAMDashboardActionFilter extends BaseActionFilter {
    getCAMDashboardPageDL(store, data) {
        const { context } = store.getState();

        const deviceType = getDeviceType(context);

        const getCAMDashboardDL = this.updateCommonDigitalData();
        getCAMDashboardDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        getCAMDashboardDL.page.pageInfo.pageType = 'account';
        getCAMDashboardDL.page.pageInfo.siteSection = 'account';
        getCAMDashboardDL.page.pageInfo.deviceType = deviceType;
        getCAMDashboardDL.page.pageInfo.searchRedirect = '';
        getCAMDashboardDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getCAMDashboardDL.page.pageInfo.version = getVersion('yoda account');
        getCAMDashboardDL.page.category = {};
        getCAMDashboardDL.page.category.primaryCategory = 'account';
        getCAMDashboardDL.page.category.subCategory1 = '';
        getCAMDashboardDL.page.category.subCategory2 = '';
        getCAMDashboardDL.page.category.department = 'account';
        getCAMDashboardDL.error = serviceErrorToAnalyticsFormat({}); // set empty error
        return getCAMDashboardDL;
    }

    // eslint-disable-next-line class-methods-use-this
    getPromotionalEmailPreferences(preferences) {
        return {
            preferences,
        };
    }
}

export default CAMDashboardActionFilter;
